import React from 'react';
import { Link } from 'react-router-dom';
import '../styles.css';

const PrivacyPolicy = () => {
  return (
    <div className="policy-wrapper">
      <div className="policy-left-section">
        <div className="policy-header">
          <div className="policy-brand-logo">
            {/* <span className="logo-icon">⏱</span> */}
            <img src="/Teamhalt.png" alt="TeamHalt" className="logo-icon" />
            <span className="logo-text">TeamHalt</span>
          </div>
        </div>
        
        <div className="policy-brand-content">
          <h1>Privacy & Security</h1>
          <p>Your privacy is our top priority. Learn how we protect and handle your personal data.</p>
          <div className="policy-features">
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span>Data Encryption</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span>Secure Storage</span>
            </div>
            <div className="feature-item">
              <span className="feature-icon">✓</span>
              <span>Your Rights Protected</span>
            </div>
          </div>
        </div>
        
        <div className="policy-footer">
          <Link to="/" className="back-login-link">
            <span>←</span> Back to Login
          </Link>
          <p className="copyright">© 2026 TeamHalt. All rights reserved.</p>
        </div>
      </div>
      
      <div className="policy-right-section">
        <div className="policy-card">
          <div className="policy-header-content">
            <div className="policy-icon">🔒</div>
            <h2>Privacy Policy</h2>
          </div>
          
          <div className="policy-content">
            <p className="policy-intro">
              At TEAMHALT PVT. LTD., we prioritize your privacy and are committed to protecting the personal data you share with us through the TEAMHALT ATTENDANCE App. This Privacy Policy describes how we collect, use, and secure your information.
            </p>
            
            <div className="policy-section">
              <h3>📱 Information We Collect</h3>
              <p>We collect information to provide, maintain, and improve our services, and to fulfill legal obligations. This includes:</p>
              <ul>
                <li><strong>User Profile Data:</strong> When you register, we gather your name, email, contact number, and role (e.g., user, admin) to personalize your experience and manage access rights.</li>
                <li><strong>Attendance Records:</strong> We collect punch-in/punch-out times, dates, and location data (if location-based attendance is enabled) to ensure accurate attendance tracking.</li>
                <li><strong>Device and Usage Data:</strong> We may collect information on your device type, IP address, and app usage to help us improve the app's functionality and troubleshoot issues.</li>
              </ul>
            </div>

            <div className="policy-section">
              <h3>📧 How We Use Your Information</h3>
              <p>Your information is used to deliver our services effectively and ensure a smooth experience. Specifically, we use it to:</p>
              <ul>
                <li>Manage and monitor attendance records.</li>
                <li>Verify your location for location-based attendance where enabled.</li>
                <li>Enhance app functionality based on usage data.</li>
                <li>Communicate important updates, new features, or policy changes.</li>
              </ul>
            </div>

            <div className="policy-section">
              <h3>🔐 Your Rights</h3>
              <p>You have control over your personal information and can exercise the following rights:</p>
              <ul>
                <li><strong>Access:</strong> Request a copy of the personal data we hold about you.</li>
                <li><strong>Correction:</strong> Update or correct inaccuracies in your information.</li>
                <li><strong>Deletion:</strong> Request deletion of your data, subject to legal requirements.</li>
                <li><strong>Opt-Out:</strong> Manage preferences for receiving marketing communications.</li>
              </ul>
            </div>

            <div className="policy-section">
              <h3>🛡️ Security</h3>
              <p>We take reasonable steps to safeguard your information from unauthorized access or disclosure. Our security measures include encryption, access controls, and regular monitoring of our systems.</p>
            </div>

            <div className="policy-section">
              <h3>📧 Changes to This Policy</h3>
              <p>We may revise this Privacy Policy periodically. When significant updates are made, we will notify you via the app or email. We encourage you to review the policy periodically.</p>
            </div>

            <div className="policy-section">
              <h3>📞 Contact Us</h3>
              <p>If you have any questions or concerns regarding this Privacy Policy or your data, please reach out to us at:</p>
              <p className="contact-info">TEAMHALT PVT. LTD.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Inline Styles for sticky left section */}
      <style>{`
        .policy-wrapper {
          display: flex;
          min-height: 100vh;
          background: var(--white);
        }

        .policy-left-section {
          flex: 0 0 45%;
          max-width: 45%;
          background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-dark) 100%);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 40px;
          position: sticky;
          top: 0;
          height: 100vh;
          overflow: hidden;
        }

        .policy-right-section {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 40px;
          background: var(--gray-100);
          overflow-y: auto;
          height: 100vh;
        }

        @media (max-width: 1024px) {
          .policy-left-section {
            display: none;
          }
          
          .policy-right-section {
            flex: none;
            width: 100%;
            min-height: 100vh;
            padding: 24px;
          }
        }
      `}</style>
    </div>
  );
};

export default PrivacyPolicy;

